<template>
    <div class="coordCorporate">
        <div class="coordCorporate_cennert">
            <div class="cennert_txt">
                <h1>
                    企业文化
                    <p>Company Culture</p>
                </h1>
                <span></span>
                <p>以3D技术展示为核心，为客户展示项目价值所在 客户的商业利润就是我们存在的价值所在</p>
            </div>
            <div class="Corporate_list">
                <ul>

                    <li>
    <div data-aos="fade-right"
     data-aos-offset="300"
     data-aos-duration="500">

                        <h3>--01--</h3>
                        <h1>企业文化</h1>
                        <p>以3D技术为核心，打造 富有创造力的3D生态产业链</p>
                        <span></span>
    </div>
                    </li>
                    <li>
    <div data-aos="fade-right"
     data-aos-offset="300"
     data-aos-duration="700">
                         <h3>--02--</h3>
                        <h1>企业使命</h1>
                        <p>用技术缔造全新视觉 享受</p>
                        <span></span>
    </div>
                    </li>
                    <li>
    <div data-aos="fade-right"
     data-aos-offset="300"
     data-aos-duration="900">
                         <h3>--03--</h3>
                        <h1>核心价值</h1>
                        <p>做正直、诚信的人,做对社会 有价值的事</p>
                        <span></span>
    </div>
                    </li>
                    <li>
    <div data-aos="fade-right"
     data-aos-offset="300"
     data-aos-duration="1100">
                         <h3>--04--</h3>
                        <h1>企业精神</h1>
                        <p>创新、分享、团结、自律</p>
                        <span></span>
    </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"coord-corporate"   
}
</script>
<style scoped>
.coordCorporate{
    height: 731px;
    width: 100%;
    background: url("../../assets/imges/coordinates/Corporate_bg.png") no-repeat center top;       
}
.coordCorporate_cennert{
    width: 1202px;
    height: 100%;
    margin: 0 auto;
}
.cennert_txt{
    width: 386px;
    height: 163px;
    float: left;
    margin: 66px 0px 0px 746px;
}
.cennert_txt h1{
    color: #fff;
    font-size: 24px;
}
.cennert_txt span{
    display: block;
    width: 22px;
    height: 2px;
    background: #fff;
    margin: 20px 0px;
}
.cennert_txt h1 p{
    font-weight: normal;
    font-size: 16px;
    line-height: 35px;
}
.cennert_txt p{
    font-size: 16px;
    color: #fff;
}
.Corporate_list{
    width: 100%;
    height: 234px;
    float: left;
    margin-top: 140px;
    padding-left: 5px;
}
.Corporate_list li{
    float: left;
    width: 216px;
    height: 234px;
    margin-right: 110px;
}
.Corporate_list li:nth-child(4){
    margin: 0;
}
.Corporate_list ul li h3{
    font-size: 28px;
    text-align: center;
    margin-bottom: 30px;
}
.Corporate_list ul li h1{
    width: 100%;
    height: 50px;
    background: #357eff;
    /* background: #000000; */
    color: #fff;
    text-align: center;
    line-height: 50px;
    font-size: 18px;
    margin-bottom: 30px;
}
.Corporate_list ul li p{
    text-align: center;
    font-size: 15px;
}
.Corporate_list ul li span{
    width: 31px;
    height: 4px;
    margin: 34px auto;
    display: block;
    background: #000000;
}
</style>


// WEBPACK FOOTER //
// src/common/coordinates/coord-corporate.vue